<script setup>
/* eslint-disable */
import { BetSlip } from '@/stores/BetSlip';
import { useCurrenciesStore } from '@/stores/currencies';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import * as Combinatorics from 'js-combinatorics';

const { t } = useI18n();
const betslipStore = BetSlip();
const currenciesStore = useCurrenciesStore();
const is_prop_betslip = ref(false);

const props = defineProps({
	betslip: {
		type: Object,
		default:null
	}
})

const calculateMultipleLabel = computed(() => {
	if (props.betslip?.betslip_type_lang) return '(' + props.betslip.betslip_type_lang + ')';
	if (betslipStore.countBetslipBets == 2) return '(' + t('betslip.doubles') + ')';
	if (betslipStore.countBetslipBets == 3) return '(' + t('betslip.trebles') + ')';
	if (betslipStore.countBetslipBets >= 4) return '(' + betslipStore.countBetslipBets + ' ' + t('betslip.folds') + ')';
	return '';
});

const calculateSinglesReturn = computed(() => {

	let possible_return = 0;
	for (const bet_uuid in betslipStore.betslip.bets) {
		if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
			const bet = betslipStore.betslip.bets[bet_uuid];
			let bet_return = bet.odd_info.price * betslipStore.betslip.system_singles_stake;
			let tax_amount = bet_return * betslipStore.betslip_tax;

			possible_return += bet_return - tax_amount;
		}
	}

	return possible_return;
});

const calculateSinglesTax = computed(() => {
	let tax_amount = 0;
	for (const bet_uuid in betslipStore.betslip.bets) {
		if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
			const bet = betslipStore.betslip.bets[bet_uuid];
			let bet_return = bet.odd_info.price * betslipStore.betslip.system_singles_stake;
			tax_amount += bet_return * betslipStore.betslip_tax;

		}
	}

	return tax_amount;
});

const calculateSystemMultipleReturnTax = computed(() => {
	if (isNaN(betslipStore.betslip.system_multiple_stake)) return 0;
	let multiple_stake = Number(betslipStore.betslip.system_multiple_stake);

	let multiple_price = 1;
	for (const bet_uuid in betslipStore.betslip.bets) {
		if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
			const bet = betslipStore.betslip.bets[bet_uuid];
			multiple_price = multiple_price * bet.odd_info.price
		}
	}

	let multiple_return = 0;
	if (betslipStore.betslip.multiple_freebet_id) {
		multiple_return = (multiple_price * multiple_stake) - multiple_stake;
		return (multiple_return * betslipStore.betslip_tax);
	} else {
		multiple_return = multiple_price * Number(multiple_stake);
		return (multiple_return - multiple_stake) * betslipStore.betslip_tax;
	}
});

const calculateSystemMultipleReturn = computed(() => {
	if (isNaN(betslipStore.betslip.system_multiple_stake)) return 0;
	let multiple_stake = Number(betslipStore.betslip.system_multiple_stake);

	let multiple_price = 1;
	for (const bet_uuid in betslipStore.betslip.bets) {
		if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
			const bet = betslipStore.betslip.bets[bet_uuid];
			multiple_price = multiple_price * bet.odd_info.price
		}
	}

	let tax_amount = 0;
	let multiple_return = 0;
	if (betslipStore.betslip.multiple_freebet_id) {
		multiple_return = (multiple_price * multiple_stake) - multiple_stake;
		if (betslipStore.betslip_tax) tax_amount = multiple_return * betslipStore.betslip_tax;
	} else {
		multiple_return = multiple_price * multiple_stake;
		if (betslipStore.betslip_tax) tax_amount = (multiple_return - betslipStore.betslip.multiple_stake) * betslipStore.betslip_tax;
	}

	return multiple_return - tax_amount;
});

const calculateSystemStake = (system_size) => {
	let system_stake = betslipStore.betslip['systemX' + system_size + '_stake'];
	let combinations = Combinatorics.Combination.of(Object.values(betslipStore.betslip.bets), system_size);

	system_stake = Number(system_stake) * Number(combinations.length);

	return system_stake;
}

const calculateSystemReturnTax = (system_size) => {
	if (isNaN(betslipStore.betslip['systemX' + system_size + '_stake'])) return 0;

	let combinations = Combinatorics.Combination.of(Object.values(betslipStore.betslip.bets), system_size);

	let total_stakes = 0;
	let return_possible = 0;
	[...combinations].forEach(combination => {
		let system_price = 1;
		combination.forEach(bet => {
			system_price = system_price * bet.odd_info.price;
		})

		total_stakes += Number(betslipStore.betslip['systemX' + system_size + '_stake']);
		return_possible += Number(betslipStore.betslip['systemX' + system_size + '_stake']) * system_price;
	});

	return (return_possible - total_stakes) * betslipStore.betslip_tax;
}

const calculateSystemReturn = (system_size) => {
	if (isNaN(betslipStore.betslip['systemX' + system_size + '_stake'])) return 0;

	let combinations = Combinatorics.Combination.of(Object.values(betslipStore.betslip.bets), system_size);

	let total_stakes = 0;
	let return_possible = 0;
	[...combinations].forEach(combination => {
		let system_price = 1;
		combination.forEach(bet => {
			system_price = system_price * bet.odd_info.price;

		})

		total_stakes += Number(betslipStore.betslip['systemX' + system_size + '_stake']);
		return_possible += Number(betslipStore.betslip['systemX' + system_size + '_stake']) * system_price;
	});

	let tax_amount = 0;
	if (betslipStore.betslip_tax) tax_amount = (return_possible - total_stakes) * betslipStore.betslip_tax;

	return return_possible - tax_amount;
}

const isBetslipSingle = () => {
	if (props.betslip?.betslip_type == "single" || props.betslip?.betslip_type == "singles") {
		is_prop_betslip.value = true;
		return true;
	}

	if (!props.betslip && (betslipStore.betslip.type == 'singles' || betslipStore.betslip.type == 'single')) {
		is_prop_betslip.value = false;
		return true;
	}

	return false;
}

const calculateSigleBetslip = computed(() => {
	if (is_prop_betslip.value) {
		return {
			total_stake: props.betslip.betslip_stake,
			total_return: props.betslip.return_possible,
			tax_amount: props.betslip.tax,
			has_sp_odd: hasSPOdd()
		}
	} else {
		return {
			total_stake: betslipStore.betslip.total_stake,
			total_return: betslipStore.betslip.total_return,
			tax_amount: betslipStore.betslip.tax_amount,
			has_sp_odd: betslipStore.hasSPOdd
		}
	}
})

const isBetMultiple = () => {
	if (props.betslip?.betslip_type == "multiple") {
		is_prop_betslip.value = true;
		return true;
	}

	if (!props.betslip && betslipStore.betslip.type == 'multiple') {
		is_prop_betslip.value = false;
		return true;
	}

	return false;
}

const calculateMultipleBetslip = computed(() => {
	let price = 1;
	if (is_prop_betslip.value) {
		for (const key in props.betslip.bets) {
			price = price * props.betslip.bets[key].odd_price;
		}

		return {
			price: price.toFixed(2),
			total_stake: props.betslip.betslip_stake,
			total_return: props.betslip.return_possible,
			tax_amount: props.betslip.tax,
			has_sp_odd: hasSPOdd()
		}
	} else {
		for (const bet_uuid in betslipStore.betslip.bets) {
			if (Object.hasOwnProperty.call(betslipStore.betslip.bets, bet_uuid)) {
				const bet = betslipStore.betslip.bets[bet_uuid];
				price = price * bet.odd_info.price;
			}
		}
		return {
			price: price.toFixed(2),
			total_stake: betslipStore.betslip.total_stake,
			total_return: betslipStore.betslip.total_return,
			tax_amount: betslipStore.betslip.tax_amount,
			has_sp_odd: betslipStore.hasSPOdd
		}
	}
})

const isBetSystem = () => {
	if (props.betslip?.betslip_type == "system" && props.betslip?.bets.length > 2) {
		is_prop_betslip.value = true;
		return true;
	}

	if (!props.betslip && betslipStore.betslip.type == 'system' && betslipStore.countBetslipBets > 2) {
		is_prop_betslip.value = false;
		return true;
	}

	return false;
}

const hasSPOdd = () => {
	let sp_odd_bets = _.filter(props.betslip.bets, function (betslip_bet) {
		return betslip_bet.sp == true;
	});

	if (sp_odd_bets.length > 0) return true;

	return false;
}

</script>
<template>
	<div v-if="isBetslipSingle()" class="row-stake-return bet-info-collapsed row-stake-return-formated">
		<div class="col-sreturn rsr-first">
			<span>{{$t('betslip.singles')}}:</span>
			<span>{{ currenciesStore.format_currency(calculateSigleBetslip.total_stake) }}</span>
		</div>
		<template v-if="!calculateSigleBetslip.has_sp_odd">
			<div v-if="calculateSigleBetslip.tax_amount > 0" class="col-sreturn rsr-first">
				<span>{{$t('betslip.tax')}}:</span>
				<span>{{ currenciesStore.format_currency(calculateSigleBetslip.tax_amount) }}</span>
			</div>
			<div class="col-sreturn rsr-third">
				<span class="font13">{{$t('betslip.to_return')}}:</span>
				<span class="font14">{{ currenciesStore.format_currency(calculateSigleBetslip.total_return) }}</span>
			</div>
		</template>
	</div>

	<div v-if="isBetMultiple()" class="row-stake-return bet-info-collapsed row-stake-return-formated">

		<div class="col-sreturn rsr-first">
			<span>{{$t('betslip.multiple')}} {{ calculateMultipleLabel }} :</span>
			<span>{{ currenciesStore.format_currency(calculateMultipleBetslip.total_stake) }}</span>
		</div>
		<div v-if="calculateMultipleBetslip.tax_amount > 0 && !calculateMultipleBetslip.has_sp_odd" class="col-sreturn rsr-first">
			<span>{{$t('betslip.tax')}}:</span>
			<span>{{ currenciesStore.format_currency(calculateMultipleBetslip.tax_amount) }}</span>
		</div>
		<div v-if="!calculateMultipleBetslip.has_sp_odd" class="col-sreturn rsr-third">
			<span class="font13">{{$t('betslip.to_return')}}:</span>
			<span class="font14">{{ currenciesStore.format_currency(calculateMultipleBetslip.total_return) }}</span>
		</div>

	</div>

	<div v-if="isBetSystem() && is_prop_betslip == false" class="row-br-box" style="margin-top: 5px;">
		<!-- Singles System -->
		<div v-if="betslipStore.betslip.system_singles_stake > 0" class="row-stake-return">
			<div class="col-sreturn rsr-first" :style="betslipStore.betslip.system_singles_stake > 0 ? 'display: flex' : ''">
				<span>{{ $t('betslip.singles') }}</span>
				<span>{{ currenciesStore.format_currency(betslipStore.betslip.system_singles_stake * Object.keys(betslipStore.betslip.bets).length) }}</span>
			</div>
			<div v-if="betslipStore.betslip_tax > 0 && !betslipStore.hasSPOdd" :style="betslipStore.betslip_tax > 0 && !betslipStore.hasSPOdd ? 'display: flex' : ''" class="col-sreturn rsr-first">
				<span>{{ $t('betslip.tax') }}:</span>
				<span>{{ currenciesStore.format_currency(calculateSinglesTax) }}</span>
			</div>

			<div v-if="!betslipStore.hasSPOdd" class="col-sreturn rsr-third" :style="!betslipStore.hasSPOdd ? 'display: flex' : ''">
				<span class="font13">{{ $t('betslip.to_return') }}:</span>
				<span class="font14">{{ currenciesStore.format_currency(calculateSinglesReturn) }}</span>
			</div>
		</div>

		<template v-for="(row, index) in (betslipStore.countBetslipBets - 2)" :key="index">
			<div v-if="betslipStore.betslip['systemX' + (index + 2) + '_stake'] > 0" class="row-stake-return">
				<div class="col-sreturn rsr-first" :style="betslipStore.betslip['systemX' + (index + 2) + '_stake'] > 0 ? 'display: flex' : ''">
					<span>{{ $t('betslip.stake_system') }} X{{ index + 2 }}</span>
					<span>{{ currenciesStore.format_currency(calculateSystemStake(index + 2)) }}</span>
				</div>

				<template v-if="!betslipStore.hasSPOdd">
					<div v-if="betslipStore.betslip_tax > 0" class="col-sreturn rsr-first" :style="betslipStore.betslip_tax > 0 && !betslipStore.hasSPOdd ? 'display: flex' : ''">
						<span>{{ $t('betslip.tax') }}:</span>
						<span>{{ currenciesStore.format_currency(calculateSystemReturnTax(index + 2)) }}</span>
					</div>

					<div class="col-sreturn rsr-third" :style="!betslipStore.hasSPOdd ? 'display: flex' : ''">
						<span class="font13">{{ $t('betslip.to_return') }}:</span>
						<span class="font14">{{ currenciesStore.format_currency(calculateSystemReturn(index + 2)) }}</span>
					</div>
				</template>
			</div>
		</template>

		<div v-if="betslipStore.betslip.system_multiple_stake > 0" class="row-stake-return">
			<div class="col-sreturn rsr-first" :style="betslipStore.betslip.system_multiple_stake > 0 ? 'display: flex' : ''">
				<span v-if="betslipStore.countBetslipBets == 2">{{ $t('betslip.doubles') }}</span>
				<span v-if="betslipStore.countBetslipBets == 3">{{ $t('betslip.trebles') }}</span>
				<span v-if="betslipStore.countBetslipBets > 3">{{ betslipStore.countBetslipBets }} {{ $t('betslip.folds') }}</span>
				<span>{{ currenciesStore.format_currency(betslipStore.betslip.system_multiple_stake) }}</span>
			</div>

			<template v-if="!betslipStore.hasSPOdd">
				<div v-if="betslipStore.betslip_tax > 0" class="col-sreturn rsr-first" :style="betslipStore.betslip_tax > 0 && !betslipStore.hasSPOdd ? 'display: flex' : ''">
					<span>{{ $t('betslip.tax') }}:</span>
					<span>{{ currenciesStore.format_currency(calculateSystemMultipleReturnTax) }}</span>
				</div>

				<div class="col-sreturn rsr-third" :style="!betslipStore.hasSPOdd ? 'display: flex' : ''">
					<span class="font13">{{ $t('betslip.to_return') }}:</span>
					<span class="font14">{{ currenciesStore.format_currency(calculateSystemMultipleReturn) }}</span>
				</div>
			</template>
		</div>
	</div>

	<div v-if="isBetSystem() && is_prop_betslip == true" class="row-stake-return bet-info-collapsed row-stake-return-formated">
		<div class="col-sreturn rsr-first">
			<span>{{$t('betslip.system')}} ({{ props.betslip.betslip_type_lang }}) :</span>
			<span>{{ currenciesStore.format_currency( props.betslip.betslip_stake) }}</span>
		</div>
		<div v-if="props.betslip.betslip_tax > 0 && !hasSPOdd()" class="col-sreturn rsr-first">
			<span>{{$t('betslip.tax')}}:</span>
			<span>{{ currenciesStore.format_currency(props.betslip.betslip_tax) }}</span>
		</div>
		<div v-if="!hasSPOdd()" class="col-sreturn rsr-third">
			<span class="font13">{{$t('betslip.to_return')}}:</span>
			<span class="font14">{{ currenciesStore.format_currency(props.betslip.return_possible) }}</span>
		</div>

	</div>

</template>
<style scoped>
	.row-stake-return .bet-placed-collapse {
		display: grid;
		grid-template-columns: 1fr auto;
		align-items: center;
		cursor: pointer;
	}

	.row-stake-return .bet-placed-collapse p {
		font-size: 11px;
		font-weight: normal;
		color: var(--white);
	}

	.row-stake-return .bet-placed-collapse .collapse-ico {
		display: flex;
	}

	.row-stake-return.bet-info-collapsed .col-sreturn {
		display: flex;
	}

	.row-stake-return .col-sreturn {
		display: none;
		width: 100%;
		justify-content: space-between;
		font-size: 11px;
		font-weight: normal;
		color: var(--white);
	}

	.row-stake-return .col-sreturn.rsr-third {
		font-weight: 500;
	}

	.row-stake-return .col-sreturn.rsr-third .font13 {
		font-size: 13px;
	}

	.row-stake-return .col-sreturn.rsr-third .font14 {
		font-size: 13px;
	}

	.row-stake-return-formated {
		margin-top: 5px;
		border-top: 0px solid var(--light-gray);
	}

	.row-stake-return {
		border-bottom: 1px solid var(--light-gray);
		padding: 21px 20px;
		display: grid;
		gap: 5px;
		background-color: var(--light-dark);
	}

	.row-stake-return:last-child {
		border-bottom: 0px solid var(--light-gray);
	}
</style>